import React from "react";
import {Button, Card, Popconfirm, Row, Space, Spin} from "antd";
import AutoForm from "./AutoForm";
import {QuestionCircleOutlined} from "@ant-design/icons";

const AutoFormCard = ({
                          title,
                          formStruct,
                          extra,
                          selectOptions = {},
                          initValues,
                          initFiles,
                          loading,
                          onFormChange,
                          onFileChange,
                          onClickSubmit,
                          onClickCancel
                      }) => {

    const handleFormChange = (change, all) => {
        onFormChange && onFormChange(change, all)
    }

    const handleFileChange = (key, files) => {
        const p = {}
        p[key] = files
        console.log(key, files)
        onFileChange && onFileChange(p)
    }

    const handleSubmit = () => {
        onClickSubmit && onClickSubmit()
    }

    const handleCancel = () => {
        onClickCancel && onClickCancel()
    }

    return (
        <>
            <Spin spinning={loading}>
                <Card title={title} extra={extra}>
                    <div style={{paddingBottom: 5}}>
                        <AutoForm
                            formStruct={formStruct}
                            selectOptions={selectOptions}
                            initValues={initValues}
                            initFiles={initFiles}
                            onFormChange={handleFormChange}
                            onFileChange={handleFileChange}
                        />
                    </div>
                    <Row justify="end" style={{paddingTop: 30}}>
                        <Space>
                            <Popconfirm
                                placement="topRight"
                                title="确定要取消编辑吗"
                                icon={<QuestionCircleOutlined style={{color: 'red'}}/>}
                                onConfirm={handleCancel}
                                okText="确定"
                                cancelText="暂不"
                            >
                                <Button>取消</Button>
                            </Popconfirm>
                            <Popconfirm
                                placement="topRight"
                                title="确定要提交吗"
                                onConfirm={handleSubmit}
                                okText="确定"
                                cancelText="暂不"
                            >
                                <Button type="primary">提交</Button>
                            </Popconfirm>
                        </Space>
                    </Row>
                </Card>
            </Spin>
        </>
    )
}

export default AutoFormCard